module.exports = __webpack_public_path__ + "img/aeroland-app-landing-image-04.cfa7e2e1.png";